const apiUrl = '/api/auth';

class ClientAuth {
	storageKey = 'skylarcmsauth';

	data( newblob ) {
		if ( newblob ) {
			localStorage.setItem( this.storageKey, JSON.stringify( newblob ) );
		}

		const val = localStorage.getItem( this.storageKey );
		return val ? JSON.parse( val ) : {};
	}

	exists() {
		return localStorage.getItem( this.storageKey ) ? true : false; //NOSONAR
	}

	clear() {
		localStorage.removeItem( this.storageKey );
	}

	get(key) {
		return this.data()[key];
	}

	set(key, value) {
		const data = this.data();
		data[key] = value;
		this.data( data );
	}

}

const authdata = new ClientAuth();

const authProvider = {
	login: async ( { username, password } ) => {

		const request = new Request(`${apiUrl}/login`, {
			method: 'POST',
			body: JSON.stringify({ username, password }),
			headers: new Headers({ 'Content-Type': 'application/json' }),
		});

		return fetch(request)
			.then(response => {
				if (response.status < 200 || response.status >= 300) {
					throw new Error(response.statusText);
				}
				return response.json();
			})
			.then(auth => {

				authdata.data( auth );
				return Promise.resolve();
			});
	},

	logout: async () => {
		authdata.clear();
		return Promise.resolve();
	},

	// Reject if error is an auth error
	checkError: async ({status}) => {
		let result;

		switch( status ) {
			// Unauthenticated, session expired
			case 401:
				authdata.clear();
				result = Promise.reject( new Error( status ) );
				break;

			// Authenticated, permission denied.
			case 403:
				result = Promise.resolve( new Error( 'Access denied' ) );
				break;

			default:
				result = Promise.resolve();
		}
		
		return result;
	},

	checkAuth: async () => { return authdata.exists() ? Promise.resolve() : Promise.reject( new Error() ) },
	getIdentity: async () => authdata.data(),
	getPermissions: async () => authdata.get('perm'),
	canAccess: async ({ action, resource }) => {
		const perm = authdata.get('perm');
		//console.log( resource, action, perm );
		return resource in perm && perm[resource].includes( action );
	}

};

export default authProvider;
